import { render, staticRenderFns } from "./addLeads.vue?vue&type=template&id=5bb1d06c&"
import script from "./addLeads.vue?vue&type=script&lang=js&"
export * from "./addLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports